import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';

import EmptyModal from './EmptyModal';
import UnsavedModal from './UnsavedModal';

function WarningModals({ formName, onSave }) {
  const { path } = useRouteMatch();

  return (
    <>
      <Route path={`${path}warning/unsaved/`}>
        <UnsavedModal formName={formName} onSave={onSave} />
      </Route>
      <Route path={`${path}warning/empty/`}>
        <EmptyModal formName={formName} />
      </Route>
    </>
  );
}

export default WarningModals;
